import React, { RefObject } from 'react';
import { connect } from 'react-redux';
import { Form } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { IReviewBookState } from '@store/slices';
import { RoomInfo } from '../room-info';
import { RootState } from '@share/utils';

import './style.scss';
import { debounce } from 'lodash';
import { HOTEL_BOOKING_GUEST_INFO_LABEL } from '@constants';

interface IMapStateToProps {
  reviewBookStore: IReviewBookState;
}

interface IProps extends IMapStateToProps, WrappedComponentProps {
  formRef: RefObject<FormInstance>;
  isCheckMainGuest: boolean;
  handleGuestFormValidation: (guestForm: boolean) => void;
}

interface IState {
  isFormValid: boolean;
}

class GuestInfoComponent extends React.Component<IProps> {

  state: IState = {
    isFormValid: false,
  };

  mainGuestData = (item: string): string => {
    const guest = this.props.reviewBookStore.guests.find((item) => item.isMainGuest === true);

    return guest ? (guest[item] as string) : '';
  };

  onFocusPhone = (): void => {
    this.props.formRef.current?.setFieldsValue({
      mainGuestPhone: this.mainGuestData('phone'),
    });
    this.checkFormValidity();
  };

  checkFormValidity = debounce(() => {
    if (!this.props.formRef.current) return;
  
    // Get only errors from visible fields (excluding saveCard and country)
    const hasErrors = this.props.formRef.current
      .getFieldsError()
      .some(({ errors }) => errors.length > 0);
  
    // Get the current field values
    const allFields = this.props.formRef.current.getFieldsValue();
  
    // Manually exclude saveCard and country from validation
    const filteredFields = Object.keys(allFields)
    .filter(key => key.length > 0 && key !== "guests[1].givenName" && key !== "guests[1].surname")
    .reduce((obj, key) => {
      obj[key] = allFields[key];
      return obj;
    }, {});
  
    // Check if all visible fields are either user-filled or pre-filled from sessionStorage
    const allFieldsFilled = Object.entries(filteredFields).every(([key, value]) => {
      return value !== undefined && value !== ""; // Ensure the field is filled
    });

  
    // Update the button state
    this.setState({ isFormValid: !hasErrors && allFieldsFilled });
  }, 500);

  componentDidMount(): void {
    const guestInfo = localStorage.getItem(HOTEL_BOOKING_GUEST_INFO_LABEL);
    const guestData = guestInfo ? JSON.parse(guestInfo) : guestInfo;
    if(guestData) {
      this.props.formRef.current?.setFieldsValue({
        mainGuestGivenName: guestData[0] ? guestData[0]?.givenName : undefined,
        mainGuestSurname: guestData[0] ? guestData[0]?.surname : undefined,
        mainGuestPhone: guestData[0] ? guestData[0]?.phone : undefined,
      })
    }
    this.checkFormValidity();
    this.props.handleGuestFormValidation(this.state.isFormValid);
  }

  componentDidUpdate(prevProps: IProps, prevState: IState) {
    if (prevState.isFormValid !== this.state.isFormValid) {
      this.props.handleGuestFormValidation(this.state.isFormValid);
    }
  }

  render(): React.ReactNode {
    const { reviewBookStore } = this.props;
    const { bookingSummary } = reviewBookStore;

    return (

      <div className="card shadow">
        <div className="card-header border-bottom p-4">
          <h4 className="card-title mb-0">
            <i className="bi bi-people me-2"></i><FormattedMessage id="guest.details" />
          </h4>
        </div>
        <div className="card-body p-4">

          <div className="guest-info">
            {/* <div className="guest-info__header">
              <h4 className="guest-info__title secondary-font">
                <FormattedMessage id="guest.info" />
              </h4>
              <p className="guest-info__description">
                <FormattedMessage id="guest.checking" />
              </p>
            </div> */}

            <Form name="guest-info-rule" ref={this.props.formRef} layout='vertical' onFieldsChange={this.checkFormValidity}
                autoComplete='off'>
              {bookingSummary.bookingCard.package.rooms.map((room, index) => (
                <RoomInfo
                  key={index}
                  room={room}
                  indexRoom={index}
                  isCheckMainGuest={this.props.isCheckMainGuest}
                  onFocusPhone={this.onFocusPhone}
                  checkFormValidity={this.checkFormValidity}
                  formRef={this.props.formRef}
                />
              ))}
            </Form>
          </div>

        </div>
      </div>




    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    reviewBookStore: state.reviewBookStore,
  };
};

export const GuestInfo = connect(mapStateToProps)(injectIntl(GuestInfoComponent));
